import { FontWeight } from '@leland-dev/leland-ui-library';
import { type FC } from 'react';

import {
  RadioToggle,
  type RadioToggleOption,
} from '../../../inputs/RadioToggle';

export enum ApplyRecurringSessionChanges {
  JUST_THIS_SESSION = 'just-this-session',
  ALL_SESSIONS = 'all-sessions',
}

interface SelectApplyRecurringSessionChangesProps {
  onChange: (value: ApplyRecurringSessionChanges) => void;
  value: ApplyRecurringSessionChanges;
}

export const SelectApplyRecurringSessionChanges: FC<
  SelectApplyRecurringSessionChangesProps
> = ({ onChange, value }) => {
  const options: RadioToggleOption[] = [
    {
      label: 'Just this session',
      value: ApplyRecurringSessionChanges.JUST_THIS_SESSION,
    },
    {
      label: 'This and following sessions',
      value: ApplyRecurringSessionChanges.ALL_SESSIONS,
    },
  ];

  return (
    <RadioToggle
      options={options}
      value={value}
      onChange={onChange}
      name="apply-changes"
      labelFontWeight={FontWeight.MEDIUM}
    />
  );
};
